import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAnalytics } from '@backstage/core-plugin-api';
import { sendTechDocsViewEvent } from '@platt/backstage-plugin-techdocs-sample-analytics-react';

interface TechDocsReaderPageWithAnalyticsProps {
  children: JSX.Element;
}

export const TechDocsReaderPageWithAnalytics = ({
  children,
}: TechDocsReaderPageWithAnalyticsProps) => {
  const { namespace, kind, name } = useParams();
  const analytics = useAnalytics();

  useEffect(() => {
    if (!namespace || !kind || !name) {
      return;
    }

    const entityRef = `${kind}:${namespace}/${name}`;

    sendTechDocsViewEvent(analytics, entityRef, kind, name, namespace);
  }, [namespace, kind, name, analytics]);

  return <>{children}</>;
};
